import { climateHistory } from '../../world/weather/climate';
import { overrideHistory, type WeatherOverride } from '../../world/weather/presets';
import { floorHour, type WeatherHistory, type WeatherSource } from '../../world/weather/types';

/** Phase 1: synchronous providers only. Phase 4 adds async live/archive providers behind this interface. */
export interface WeatherProvider {
  readonly source: WeatherSource;
  history(instant: number): WeatherHistory;
}

export class WeatherService {
  private override: WeatherOverride | undefined;
  private cacheKey = '';
  private cache: WeatherHistory | undefined;

  constructor(private readonly opts: { seed: number; timeZone: string; override?: WeatherOverride | undefined }) {
    this.override = opts.override;
  }

  setOverride(o: WeatherOverride | undefined): void {
    this.override = o;
    this.cacheKey = '';
  }

  historyFor(instant: number): WeatherHistory {
    const key = `${floorHour(instant)}|${JSON.stringify(this.override ?? null)}`;
    if (key !== this.cacheKey || !this.cache) {
      this.cache = this.provider().history(instant);
      this.cacheKey = key;
    }
    return this.cache;
  }

  private provider(): WeatherProvider {
    const o = this.override;
    if (o) return { source: 'override', history: (t) => overrideHistory(t, o) };
    return { source: 'climate', history: (t) => climateHistory(t, this.opts.seed, this.opts.timeZone) };
  }
}
